import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import { Checkbox } from "../../../components/ui/Checkbox";
import axios from "axios";
import { toast } from "react-toastify";
import * as URLS from "../../../urls";
import { useTranslation } from "react-i18next";

const LoginForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    account: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.account) {
      newErrors.account = t("emailRequired");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.account)) {
      newErrors.account = t("emailInvalid");
    }

    if (!formData.password) {
      newErrors.password = t("passwordRequired");
    } else if (formData.password.length < 6) {
      newErrors.password = t("passwordMinLength");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const response = await axios.post(`${URLS.baseUrl}/${URLS.loginURL}`, {
        account: formData.account,
        password: formData.password,
      });

      if (response.status === 200) {
        if (formData.rememberMe) {
          localStorage.setItem("rememberMe", "true");
        }
        localStorage.setItem("Token", response.data.data.token);
        localStorage.setItem(
          "permissions",
          JSON.stringify(response.data.data.user.permissions)
        );
        localStorage.setItem(
          "user",
          JSON.stringify({
            id: response.data.data.user.id,
            name: response.data.data.user.name,
            account: response.data.data.user.email,
          })
        );
        navigate("/admin-dashboard");
      } else {
        response.payload?.errors?.forEach((error) => toast.warn(error));
      }
    } catch (error) {
      const errors = error?.response?.data?.errors;
      if (errors && typeof errors === "object") {
        // استخراج كل مصفوفات الرسائل ودمجها في مصفوفة واحدة
        const allErrors = Object.values(errors).flat();
        allErrors.forEach((msg) => toast.warn(msg));
      } else {
        toast.error(t("generalError"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    alert(t("forgotPassword"));
  };

  return (
    <div
     // dir="ltr"
      className="w-full max-w-md mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md"
    >
      <form onSubmit={handleSubmit} className="space-y-6 text-left">
        {/* General Error Message */}
        {errors.general && (
          <div className="bg-red-100 border border-red-300 rounded-md p-3 flex items-center space-x-2 space-x-reverse">
            <Icon
              name="AlertCircle"
              size={16}
              className="text-red-600 flex-shrink-0"
            />
            <span className="text-sm text-red-600">{errors.general}</span>
          </div>
        )}

        {/* Email Field */}
        <Input
          label={t("email")}
          type="email"
          name="account"
          placeholder={t("email")}
          value={formData.account}
          onChange={handleInputChange}
          error={errors.account}
          required
          disabled={isLoading}
          className="text-left"
        />

        {/* Password Field */}
        <Input
          label={t("password")}
          type="password"
          name="password"
          placeholder={t("password")}
          value={formData.password}
          onChange={handleInputChange}
          error={errors.password}
          required
          disabled={isLoading}
          className="text-left"
        />

        {/* Remember Me and Forgot Password */}
        <div className="flex items-center justify-between">
          <Checkbox
            label={t("rememberMe")}
            name="rememberMe"
            checked={formData.rememberMe}
            onChange={handleInputChange}
            disabled={isLoading}
            className="text-left"
          />

          <button
            type="button"
            onClick={handleForgotPassword}
            className="text-sm text-green-600 hover:text-green-700 transition"
            disabled={isLoading}
          >
            {t("forgotPassword")}
          </button>
        </div>

        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isLoading}
          disabled={isLoading}
          className="m-auto width-[90%] py-3 text-lg font-semibold flex flex-row-reverse justify-center items-center space-x-2 space-x-reverse text-center"
        >
          {isLoading ? t("signingIn") : t("signIn")}
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;
